import React from 'react';

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({ label, ...props }) => {
  return (
    <label className="inline-flex items-center">
      <input
        type="checkbox"
        className="form-checkbox h-4 w-4 text-primary border-border rounded focus:ring-ring"
        {...props}
      />
      {label && <span className="ml-2 text-text">{label}</span>}
    </label>
  );
};

export default Checkbox;